type NativeHandlerName =
  | 'authRequired'
  | 'noHistory'
  | 'onStartTestMobile'
  | 'onFinishTestMobile'
  | 'onDownloadRequested'
  | 'onOpenTgBot'
  | 'onOpenExternalLink';

export const MOBILE_AUTH_REQUIRED_EVENT = 'mobile-auth-required';

const dispatchAuthRequiredEvent = (nativeTriggered: boolean) => {
  try {
    const event = new CustomEvent(MOBILE_AUTH_REQUIRED_EVENT, {
      bubbles: true,
      detail: { nativeTriggered },
    });

    document.dispatchEvent(event);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('[native-bridge]: auth required event dispatch failed', error);
  }
};

/**
 *Вызов нативного обработчика во WebView.
 */
export const callNative = <Payload = unknown>(handler: NativeHandlerName, payload?: Payload): void => {
  try {
    if (window.flutter_inappwebview?.callHandler) {
      // eslint-disable-next-line no-console
      console.log('callNative', handler, payload);
      window.flutter_inappwebview.callHandler(handler, payload);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('[native-bridge]: handler call failed', error);
  }
};

export const notifyAuthRequired = () => {
  dispatchAuthRequiredEvent(true);
  callNative('authRequired');
};
